
import {calculateFileMD5} from "@/utils/md5";
import {isExistFile, mergeFile, uploadFile} from "@/api/fileUpload/upload";

export function checkMd5(file) {
  return new Promise((resolve, reject) => {
    let returnData = {}
    let file_md5 = ''
    calculateFileMD5(file).then(md5 => {// 计算文件的 MD5 校验码
      file_md5 = md5
      returnData.file_md5 = file_md5
      returnData.isExist=false
      returnData.fileName=file.name
      isExistFile(file_md5).then(res => {
        if (!res.data) { // false//不存在，就上传
          sliceFile(file, file_md5).then(res => {
            returnData.flag = res
            resolve(returnData)
          })
        } else {
          returnData.flag = true
          returnData.isExist=true
          resolve(returnData)
        }
      }).catch(err => {
      })
    });
  })
}
function sliceFile(file, file_md5) {
// 分割文件并上传
  return new Promise((resolve, reject) => {
    const chunk_size = 5 * 1024 * 1024; // 5MB
    const chunks = Math.ceil(file.size / chunk_size);
    const lastIndex = file.name.lastIndexOf('.')
    const fileName = file.name.substring(0, lastIndex)
    const fileType = file.name.substring(lastIndex + 1)
    const fileLength=file.size
    let flag = false
    let req=[chunks]
    for (let i = 0; i < chunks; i++) {
      const start = i * chunk_size;
      const end = Math.min(file.size, start + chunk_size);
      const chunk = file.slice(start, end);
      // 将 chunk 上传到后端服务器
      let formData = new FormData
      const seq = i + 1
      formData.set('file', chunk)
      formData.set('hash', file_md5)
      formData.set('fileName', fileName)
      formData.set('seq', seq)
      formData.set('type', fileType)
      // uploadFile(formData).then(res => {
      //   console.log('分片',seq)
      //   if (res.code !== 200) {
      //     allUploadFlag = false
      //   }
      // });
      req[i]=uploadFile(formData)
    }
    Promise.all(req).then(function (data){
      const filterRes=data.filter(item=>item.code!==200)
      if(filterRes.length<1){
        const mergeData = {
          fileName: fileName,
          type: fileType,
          hash: file_md5,
          length: fileLength,
        }
        const delay = chunks === 1 ? 300 : 0;
        setTimeout(() => {
          mergeFiles(mergeData).then(flags => {
            flag = flags;
            resolve(flag);
          });
        }, delay);
      }else {
        resolve(false)
      }
    }).catch(error=>{
      reject(false)
    })
  })
}
//合并文件
function mergeFiles(mergeData) {
  return new Promise((resolve, reject) => {
    mergeFile(mergeData).then(res => {
      if (res.code === 200) {
        resolve(true)
      } else {
        resolve(false)
      }
    }).catch(error => {
      reject(error);
    });
  })
}
